import React, { useEffect, useState } from "react";
import { 
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button, 
  Table, 
  Row, 
  Input, 
  Col, 
  FormGroup, 
  ButtonGroup, 
  Label } from "reactstrap";
import swal from "sweetalert";
import { PDFExport } from "@progress/kendo-react-pdf";
import { MdViewColumn } from 'react-icons/md'

import { addMember } from "../ApiMember";
import {
  GetLanguageString,
  GetSortingUI,
  NoResult,
  SetReportTitle,
} from "../../helper/Components";
import SearchReport from "./SearchReport";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";
import SendSMSModal from "../../SMSMessage/SendSMS";
import { LoadingSpinner, isUrdu } from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { t } from "i18next";
import { saveAs } from "file-saver";
import useSorting from "../../shared/useSorting";
import { FcPrint } from "react-icons/fc";
import { RiFileExcel2Line } from "react-icons/ri";

const initialValues = {
  name: "neutral",
  dateOfRegistration: "neutral",
  registrationNumber: "neutral",
  memberType: "neutral",
  responsbilities: "neutral",
};

const ReportList = () => {
  const [loading, setLoading] = useState(false);
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const memberId = parseInt(encryptStorage.getItem("memberId"));
  const [members, setMembers] = useState([]);
  const [reportTitle, setReportTitle] = useState("");
  const [modal, setModal] = useState(false);
  const [memberSMSStatus, setMemberSMSStatus] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [searchButton, setSearchButton] = useState(false);
  const [selecteAllMembers, setSelecteAllMembers] = useState(false);
  const [smsModal, setSmsModal] = useState(false);
  const [reportSearchMemberModel, setReportSearchMemberModel] = useState({
    isSubUnits: true,
    includeEXMember: false,
    complete: true,
    inComplete: false,
    includeCourse: true,
    attendanceStatus: 0,
    isOnTime: true,
    unitId: loggedInUnitId,
    loggedInUnitId: loggedInUnitId,
    courseStartDate: null,
    courseEndDate: null,
    eventStartDate: null,
    eventEndDate: null,
    serachButton: true,
  });

  const [showColumns, setShowColumns] = useState({
    id: false,
		serialNumber: false,
		registrationNumber: true,
		name: true,
		fatherName: true,
		dateOfBirth: false,
		dateOfRegistration: false,
		dateOfFirstBait: false,
		dateOfSecondBait: false,
		dateOfThirdBait: false,
		country: false,
		city: false,
		halqa: true,
		tanzeem: false,
		usra: false,
		nazam: true,
		memberType: true,
		responsbilities: true,
		emailAndPhoneNumber: false,
		currentAddress: true,
		permanentAddress: false,
		nativeTown: false,
		bloodGroup: false,
		education: false,
		occupation: false,
    skill: false,
		dateOfMultazim: false,
		mubtadiNisaab: false,
		multazimNisaab: false,
		zimedaraanNisaab: false,
		mudariseenNisaab: false,
    dawatiNisaab: false,
		mubtadiTarbiyatiCourse: false,
		multazimTarbiyatiCourse: false,
		nuqabaCourse: false,
		mudariseenCourse: false,
		mudariseenRefresherCourse: false,
		tajweedTest: false,
		arabicTest: false,
		registeredMudaris: false,
		acceptedMudaris: false,
		markaziMudaris: false,
  });

  const { sortObject, handleSorting } = useSorting(initialValues);

  const pdfExportComponent = React.useRef(null);

  // const exportPDFWithComponent = () => {
  //   if (pdfExportComponent.current) {
  //     pdfExportComponent.current.save();
  //   }
  // };

  useEffect(() => {
    if (searchButton) {
      setLoading(true);
      let tempSortObject = {
        isFullNameDescending: sortObject.name === "descending",
        isFullNameAscending: sortObject.name === "ascending",
        isJoiningDateDescending: sortObject.dateOfRegistration === "descending",
        isJoiningDateAscending: sortObject.dateOfRegistration === "ascending",
        isRegNoAscending: sortObject.registrationNumber === "ascending",
        isRegNoDescending: sortObject.registrationNumber === "descending",
        isMemberTypeAscending: sortObject.memberType === "ascending",
        isMemberTypeDescending: sortObject.memberType === "descending",
        isResponsbilitiesAscending: sortObject.responsbilities === "ascending",
        isResponsbilitiesDescending:
          sortObject.responsbilities === "descending",
      };
      reportSearchMemberModel.sortModel = tempSortObject;

      addMember()
        .getMembersReport(reportSearchMemberModel)
        .then((res) => {
          setMembers(res.data);
          let temp = [];
          res.data.forEach((m) => temp.push({ status: false }));
          setSelectedMembers(temp);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  }, [reportSearchMemberModel, sortObject, searchButton]);

  useEffect(() => {
    if (reportTitle !== "") window.print();
  }, [reportTitle]);

  useEffect(() => {
    addMember()
      .checkMemberCanSendSMS(memberId)
      .then((res) => {
        setMemberSMSStatus(res.data);
      })
      .catch((err) => console.log(err));
  }, [memberId]);

  const handleReportTitle = () => {
    setModal(true);
  };

  const excelDownload = () => {
    const tempData = {
      members: members,
      columnModel: showColumns,
    };

    addMember()
      .generateMembersReport(tempData)
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "Member.xlsx");
      })
      .catch((err) => console.log(err));
  };

  const handleChangeStatus = (status, index, number) => {
    let tempList = [...selectedMembers];
    tempList[index].status = status;
    if (status) tempList[index].mobileNo = number;
    setSelectedMembers(tempList);
  };

  const handleSelectAllMembers = () => {
    let temp = [];
    if (selecteAllMembers) {
      members.forEach((m) => temp.push({ status: false }));
    } else {
      members.forEach((m) => temp.push({ status: true, mobileNo: m.phone }));
    }
    setSelectedMembers(temp);
    setSelecteAllMembers(!selecteAllMembers);
  };

  const IsMemberSelected = () => {
    let memberStatus = false;
    for (let i = 0; i < selectedMembers.length; i++) {
      if (selectedMembers[i].status) {
        memberStatus = true;
        break;
      }
    }
    return memberStatus;
  };

  const handleSMSModel = () => {
    if (IsMemberSelected()) {
      setSmsModal(true);
    } else {
      swal({
        title: t("sms_error"),
        className: GetSelectedLanguage() === "en" ? "" : "ur",
        icon: "warning",
      });
    }
  };

  const handleShowColumns = (e) => {
    const {name, value} = e.target;
    let v = value;
    if (value === "true") v = true;
    else v = false;
    setShowColumns({
      ...showColumns,
      [name]: v
    });
  };

  const columnOptions = [
    { columnName: "id", label: "ID", name: "member_report_member_id" },
    { columnName: "serialNumber", label: "Serial Number", name: "member_report_member_serialNumber" },
    { columnName: "registrationNumber", label: "Registration Number", name: "member_report_member_registrationNumber" },
    { columnName: "name", label: "Name", name: "member_report_member_name" },
    { columnName: "fatherName", label: "Father Name", name: "member_report_member_fatherName" },
    { columnName: "dateOfBirth", label: "Date of Birth", name: "member_report_member_dateOfBirth" },
    { columnName: "dateOfRegistration", label: "Date of Registration", name: "member_report_member_dateOfRegistration" },
    { columnName: "dateOfFirstBait", label: "Date of First Bait", name: "member_report_member_dateOfFirstBait" },
    { columnName: "dateOfSecondBait", label: "Date of Second Bait", name: "member_report_member_dateOfSecondBait" },
    { columnName: "dateOfThirdBait", label: "Date of Third Bait", name: "member_report_member_dateOfThirdBait" },
    { columnName: "country", label: "Country", name: "member_report_member_country" },
    { columnName: "city", label: "City", name: "member_report_member_city" },
    { columnName: "halqa", label: "Halqa", name: "member_report_member_halqa" },
    { columnName: "tanzeem", label: "Tanzeem", name: "member_report_member_tanzeem" },
    { columnName: "usra", label: "Usra", name: "member_report_member_usra" },
    { columnName: "nazam", label: "Nazam", name: "member_report_member_nazam" },
    { columnName: "memberType", label: "Member Type", name: "member_report_member_memberType" },
    { columnName: "responsbilities", label: "Responsibilities", name: "member_report_member_responsbilities" },
    { columnName: "emailAndPhoneNumber", label: "Email and Phone Number", name: "member_report_member_emailAndPhoneNumber" },
    { columnName: "currentAddress", label: "Current Address", name: "member_report_member_currentAddress" },
    { columnName: "permanentAddress", label: "Permanent Address", name: "member_report_member_permanentAddress" },
    { columnName: "nativeTown", label: "Native Town", name: "member_report_member_nativeTown" },
    { columnName: "bloodGroup", label: "Blood Group", name: "member_report_member_bloodGroup" },
    { columnName: "education", label: "Education", name: "member_report_member_education" },
    { columnName: "occupation", label: "Occupation", name: "member_report_member_occupation" },
    { columnName: "skill", label: "Skill", name: "member_report_member_skill" },
    { columnName: "dateOfMultazim", label: "Date of Multazim", name: "member_report_member_dateOfMultazim" },
    { columnName: "mubtadiNisaab", label: "Mubtadi Nisaab", name: "member_report_member_mubtadiNisaab" },
    { columnName: "multazimNisaab", label: "Multazim Nisaab", name: "member_report_member_multazimNisaab" },
    { columnName: "zimedaraanNisaab", label: "Zimedaraan Nisaab", name: "member_report_member_zimedaraanNisaab" },
    { columnName: "mudariseenNisaab", label: "Mudariseen Nisaab", name: "member_report_member_mudariseenNisaab" },
    { columnName: "dawatiNisaab", label: "Dawati Nisaab", name: "member_report_member_dawatiNisaab" },
    { columnName: "mubtadiTarbiyatiCourse", label: "Mubtadi Tarbiyati Course", name: "member_report_member_mubtadiTarbiyatiCourse" },
    { columnName: "multazimTarbiyatiCourse", label: "Multazim Tarbiyati Course", name: "member_report_member_multazimTarbiyatiCourse" },
    { columnName: "nuqabaCourse", label: "Nuqaba Course", name: "member_report_member_nuqabaCourse" },
    { columnName: "mudariseenCourse", label: "Mudariseen Course", name: "member_report_member_mudariseenCourse" },
    { columnName: "mudariseenRefresherCourse", label: "Mudariseen Refresher Course", name: "member_report_member_mudariseenRefresherCourse" },
    { columnName: "tajweedTest", label: "Tajweed Test", name: "member_report_member_tajweedTest" },
    { columnName: "arabicTest", label: "Arabic Test", name: "member_report_member_arabicTest" },
    { columnName: "registeredMudaris", label: "Registered Mudaris", name: "member_report_member_registeredMudaris" },
    { columnName: "acceptedMudaris", label: "Accepted Mudaris", name: "member_report_member_acceptedMudaris" },
    { columnName: "markaziMudaris", label: "Markazi Mudaris", name: "member_report_member_markaziMudaris" }
  ];

  const getSortingUI = (column) => {
    switch (column) {
      case 'registrationNumber':
      case 'name':
      case 'dateOfRegistration':
      case 'memberType':
      case 'responsbilities':
        return <GetSortingUI sortObject={sortObject} name={column} isReport />;
      default:
        return '';
    }
  };
  
  return (
    <div>
      {modal ? (
        <SetReportTitle setModal={setModal} setReportTitle={setReportTitle} />
      ) : null}
      {smsModal ? (
        <SendSMSModal
          setModal={setSmsModal}
          memberList={selectedMembers}
          memberListLength={selectedMembers.length}
        />
      ) : null}
      <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
        <div className="ibox noprint">
          <div className="ibox-title">
            <h5>{<GetLanguageString props="common_generate_report" />}</h5>
          </div>
          <div className="ibox-content">
            <SearchReport
              reportSearchMemberModel={reportSearchMemberModel}
              setReportSearchMemberModel={setReportSearchMemberModel}
              setSearchButton={setSearchButton}
            />
            {memberId !== 0 && memberSMSStatus ? (
              <Row className="m-t-md">
                <Col>
                  <FormGroup>
                    <Button color="success" onClick={handleSMSModel}>
                      {<GetLanguageString props="sms_send_sms" />}
                    </Button>
                  </FormGroup>
                </Col>
              </Row>
            ) : null}
          </div>
        </div>
        
        {searchButton ? (
          !loading ? (
            <div className="ibox">
              <div className="ibox-title">
                <h5>
                  {<GetLanguageString props="member_report_members_details" />}
                </h5>
                {members.length !== 0 ? (
                  <>
                  <ButtonGroup className={GetCustomStyles().btn_group_style}>
                    <Button
                      color="default"
                      size="sm"
                      onClick={excelDownload}
                    >
                      <RiFileExcel2Line
                        size={15}
                        color="#009440"
                        style={{ marginRight: 3, marginBottom: 1 }}
                      />
                      {<GetLanguageString props="member_report_export_excel" />}
                    </Button>
                    <Button
                      color="default"
                      size="sm"
                      onClick={handleReportTitle}
                    >
                      <FcPrint
                        size={15}
                        className={GetCustomStyles().fa_style}
                      />
                      {<GetLanguageString props="common_print" />}
                    </Button>
                    <ColumnDropdown columnOptions={columnOptions} showColumns={showColumns} handleShowColumns={handleShowColumns} />
                    </ButtonGroup>
                  </>
                ) : null}
              </div>
              <PDFExport
                ref={pdfExportComponent}
                fileName="MembersReport"
                scale={0.6}
                paperSize="A4"
                alignItems="center"
              >
                <div className="ibox-content ibox-center" id="section-to-print">
                  <Row className="print">
                    <div className="text-center">
                      <h3>Title : {reportTitle}</h3>
                    </div>
                  </Row>
                  {members.length !== 0 &&
                  members.length === selectedMembers.length ? (
                    <div className="table-responsive">
                      <Table className="table-bordered">
                        <thead>
                          <tr>
                            {memberId !== 0 && memberSMSStatus ? (
                              <th className="noprint">
                                <Input
                                  id="selectAll"
                                  type="checkbox"
                                  checked={selecteAllMembers}
                                  name="selectAll"
                                  className="big-checkbox"
                                  onChange={handleSelectAllMembers}
                                />
                              </th>
                            ) : null}
                            <th>#</th>
                            {columnOptions.map((option, index) => (
                              <ShowTableHeader
                                key={index}
                                show={showColumns[option.columnName]}
                                name={option.name}
                                onClick={() => handleSorting(option.columnName)}
                                className="cursor-pointer"
                              >
                                {getSortingUI(option.columnName)}
                              </ShowTableHeader>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {members?.map((record, index) => {
                            return (
                              <tr key={index}>
                                {memberId !== 0 && memberSMSStatus ? (
                                  <td className="noprint">
                                    <Input
                                      id={"select " + index}
                                      type="checkbox"
                                      checked={selectedMembers[index].status}
                                      className="big-checkbox"
                                      onChange={() =>
                                        handleChangeStatus(
                                          !selectedMembers[index].status,
                                          index,
                                          record?.emailAndPhoneNumber
                                        )
                                      }
                                    />
                                  </td>
                                ) : null}
                                <td>{index + 1}</td>
                                {Object.keys(showColumns).map((column, columnIndex) => (
                                  showColumns[column] && (
                                    <td key={columnIndex} className={getColumnClassName(record, column)}>
                                      {getColumnContent(record, column)}
                                    </td>
                                  )
                                ))}
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <NoResult />
                  )}
                </div>
              </PDFExport>
            </div>
          ) : (
            LoadingSpinner()
          )
        ) : null}
      </div>
    </div>
  );
};

const ColumnDropdown = ({ columnOptions, showColumns, handleShowColumns }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle caret className="btn btn-default" >
          <MdViewColumn  style={{ marginRight: 3, marginBottom: 1 }} size={18}/>
          {<GetLanguageString props="member_report_columns" />}
        </DropdownToggle>
        <DropdownMenu style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {columnOptions.map((option, index) => (
            <DropdownItem key={index} toggle={false}>
              <FormGroup check className='mb-0'>
                <Label check>
                  <Input
                    id={option.columnName}
                    type="checkbox"
                    name={option.columnName}
                    checked={showColumns[option.columnName]}
                    value={!showColumns[option.columnName]}
                    onChange={handleShowColumns}
                  />{' '}
                  <span className='tag is-light ml-2'>
                  {<GetLanguageString props={option.name} />}
                  </span>
                </Label>
              </FormGroup>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
  );
};


const getColumnClassName = (record, column) => {
  switch (column) {
    case 'name':
    case 'fatherName':
    case 'halqa':
    case 'tanzeem':
    case 'usra':
    case 'nazam':
    case 'memberType':
    case 'country':
    case 'city':
    case 'arabicTest':
    case 'tajweedTest':
      return 'ur';
    case 'currentAddress':
      return isUrdu(record?.currentAddress) ? 'ur' : '';
    case 'occupation':
      return isUrdu(record?.occupation) ? 'ur' : '';
    case 'skill':
      return isUrdu(record?.skill) ? 'ur' : '';
    case 'mubtadiNisaab':
    case 'multazimNisaab':
    case 'zimedaraanNisaab':
    case 'mudariseenNisaab':
    case 'dawatiNisaab':
    case 'registeredMudaris':
    case 'acceptedMudaris':
    case 'markaziMudaris':
      return 'text-center';
    default:
      return '';
  }
};

const getColumnContent = (record, column) => {
  switch (column) {
    case 'responsbilities':
      return record?.responsbilities?.split(",").map((item, index) => (
        <Button
          key={index}
          size="xs"
          color="info"
          className="label label-info m-r-xs"
        >
          <h5 className="ur">{item}</h5>
        </Button>
      ));
    case 'emailAndPhoneNumber':
      return record?.emailAndPhoneNumber?.split(",").map((phoneNumber, index) => (
        <div key={index}>{phoneNumber}</div>
      ));
    case 'education':
      return record?.education?.split(",").map((ed, index) => (
        <div key={index}>{ed}</div>
      ));
    case 'occupation':
      return record?.occupation?.split(",").map((oc, index) => (
        <div key={index}>{oc}</div>
      ));
    case 'skill':
      return record?.skill?.split(",").map((sk, index) => (
        <div key={index}>{sk}</div>
      ));
    case 'mubtadiNisaab':
    case 'multazimNisaab':
    case 'zimedaraanNisaab':
    case 'mudariseenNisaab':
    case 'dawatiNisaab':
    case 'registeredMudaris':
    case 'acceptedMudaris':
    case 'markaziMudaris':
        return  record?.[column] ? ( <i className={"fa fa-2x fa-check "} style={{ color: "green" }} /> ) : 
                                    ( <i className={"fa fa-2x fa-times "} style={{ color: "red" }} /> );
    default:
      return record?.[column];
  }
};

const ShowTableHeader = ({ show, name, onClick, className, children }) => {
  return (
    show ? (
      <th className={className} onClick={onClick}>
        <GetLanguageString props={name} />
        {children}
      </th>
    ) : null
  )
}

export default ReportList;
